export default function AuthModals({
  showLogin,
  setShowLogin,
  showRegister,
  setShowRegister,
  authError,
  loginSubmit,
  loginForm,
  setLoginForm,
  registerSubmit,
  registerForm,
  setRegisterForm,
  authBusy
}) {
  return (
    <>
      {showLogin && (
        <div
          className="overlay"
          onClick={() => setShowLogin(false)}
        >
          <section
            className="product-modal"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              className="modal-close"
              onClick={() => setShowLogin(false)}
            >
              ×
            </button>

            <h2>Iniciar sesión</h2>

            {authError && (
              <div className="catalog-error">
                {authError}
              </div>
            )}

            <form onSubmit={loginSubmit}>
              <input
                type="email"
                placeholder="Correo"
                value={loginForm.email}
                onChange={(event) =>
                  setLoginForm({
                    ...loginForm,
                    email: event.target.value
                  })
                }
              />

              <input
                type="password"
                placeholder="Contraseña"
                value={loginForm.password}
                onChange={(event) =>
                  setLoginForm({
                    ...loginForm,
                    password: event.target.value
                  })
                }
              />

              <button
                type="submit"
                disabled={authBusy}
              >
                {authBusy ? "Validando..." : "Ingresar"}
              </button>
            </form>
          </section>
        </div>
      )}

      {showRegister && (
        <div
          className="overlay"
          onClick={() => setShowRegister(false)}
        >
          <section
            className="product-modal"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              className="modal-close"
              onClick={() => setShowRegister(false)}
            >
              ×
            </button>

            <h2>Registro</h2>

            {authError && (
              <div className="catalog-error">
                {authError}
              </div>
            )}

            <form onSubmit={registerSubmit}>
              <input
                type="text"
                placeholder="Nombre completo"
                value={registerForm.full_name}
                onChange={(event) =>
                  setRegisterForm({
                    ...registerForm,
                    full_name: event.target.value
                  })
                }
              />

              <input
                type="email"
                placeholder="Correo"
                value={registerForm.email}
                onChange={(event) =>
                  setRegisterForm({
                    ...registerForm,
                    email: event.target.value
                  })
                }
              />

              <input
                type="text"
                placeholder="Teléfono"
                value={registerForm.phone}
                onChange={(event) =>
                  setRegisterForm({
                    ...registerForm,
                    phone: event.target.value
                  })
                }
              />

              <input
                type="password"
                placeholder="Contraseña"
                value={registerForm.password}
                onChange={(event) =>
                  setRegisterForm({
                    ...registerForm,
                    password: event.target.value
                  })
                }
              />

              <button
                type="submit"
                disabled={authBusy}
              >
                {authBusy ? "Registrando..." : "Crear cuenta"}
              </button>
            </form>
          </section>
        </div>
      )}
    </>
  );
}
